 import { Injectable } from '@angular/core';
import { Platform } from 'ionic-angular';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take'
import { AngularFire, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2';
import {appState} from './appState';
import { Subject } from 'rxjs/Subject';
declare var firebase: any;

export class log {

    
    day: number;
    month: number;
    year: number;
    week: number;
    event: string;
    milage: number;
    duration: number;
    runningType: string;
    cyclingTypes: string;
    swimmingTypes:string
    swimmingStyleTypes: string;

    runningTypeOther: string;
    cyclingTypesOther: string;
    swimmingTypesOther: string
    swimmingStyleTypesOther: string;

    rating: string;
    comment: string;
    runningOthers: string;
    constructor(public key: string, public person: string) {

    }
    toJson() {
        return {
            person: this.person,
            day: this.day,
            month: this.month,
            year: this.year,
            week: this.week,
            event: this.event,
            milage: this.milage,
            duration: this.duration,
            runningType: this.runningType,
            cyclingTypes: this.cyclingTypes,
            swimmingTypes: this.swimmingTypes,
            swimmingStyleTypes: this.swimmingStyleTypes,

            runningTypeOther: this.runningTypeOther,
            cyclingTypesOther: this.cyclingTypesOther,
            swimmingTypesOther: this.swimmingTypesOther,
            swimmingStyleTypesOther: this.swimmingStyleTypesOther,

            rating: this.rating,
            comment: this.comment,
            
        }
    }
}
@Injectable()
export class logModel {
    meRef: FirebaseObjectObservable<any>;
    parentRef: FirebaseListObservable<any>;
    me: log = new log('', '');
    
    constructor(
        private af: AngularFire,
        private platform: Platform,
        private _appState: appState

    ) {
        var that = this;        
    }
    createIfNotExist(uid) {
        var that = this;
        that.meRef = that.af.database.object('/logs/' + uid);
        that.parentRef = that.af.database.list('/logs/');
        that.watch();
        var objSubscribe = that.meRef.take(1).map(snapshot => {
            if (snapshot.$value !== null) {
                that.me = snapshot;
            } else {
                //var a = that.parentRef.push({ 'key': auth.uid, 'name': 'rama' }); 
                that.af.database.object('/logs/' + uid).set(new log(uid, 'rama'));
            }
        });
    }
    createlog(newlog: log) {
        var that = this;
        that.parentRef = that.af.database.list('/logs/' + that._appState.auth.uid+ "/" + newlog.year + "/" +newlog.month);
        that.parentRef.push(newlog);
    }
    watch() {
        this.meRef.subscribe(obj => {
            this.me = Object.assign(this.me, obj);
        });
    }
    update() {
        this.meRef.update(this.me.toJson());
    }
    getData(person, year, month, week) {
        var sizeSubject = new Subject();
        var that = this;
        var data: any = [];
        that.parentRef = that.af.database.list('/logs/' + that._appState.auth.uid + "/" + year + "/" + month, {
            query: {
                orderByChild: 'week',
                equalTo: sizeSubject
            }
        })
        that.parentRef.subscribe(snapshot => {
            data.splice(0, data.length);
            data = Object.assign(data, snapshot);
            console.log(data);
        });
        sizeSubject.next(week);
        return data;
    }
    delete(obj) {        
        this.parentRef.remove(obj.$key);
    }
}



// WEBPACK FOOTER //
// ./src/model/logsModel.ts